<template>
  <div class="book">
    <div class="page left">
        <h1>五輪書序文</h1>
        <p class="kobun block"><strong>兵法の道、二天一流と号し</strong></p>
        <p class="genndaibun">兵法の道を二天一流と名づけて</p>
        
        <p class="kobun block"><strong>数年鍛練の事、始て書物に顕さんと思</strong></p>
        <p class="genndaibun">長年修行してきたことを、初めて書物に記述しようと思い</p>
        
        <p class="kobun block"><strong>時、寛永二十年十月上旬の比、九州肥後の地岩戸山に上り、天を拜し、觀音を礼し、佛前に向</strong></p>
        <p class="genndaibun">時に寛永二十年（1643）十月上旬の頃、九州肥後の地にある岩戸山に登って、天を拜し、観音を礼拝し、仏前に向った。</p>
        
        <p class="kobun block"><strong>生國播磨の武士、新免武藏守藤原玄信、年つもりて六十。</strong></p>
        <p class="genndaibun">生国播磨の武士、新免武蔵守藤原玄信、年齢は積み重なってもう六十</p>
        
        <p class="kobun block"><strong>われ若年の昔より、兵法の道に心をかけ、十三歳にして始て勝負をす。</strong></p>
        <p class="genndaibun">私は若年の昔より兵法の道を心がけ、十三歳にして初めて決闘勝負をするようになった。</p>
        
        <p class="kobun block"><strong>其あひて、新當流有馬喜兵衛と云兵法者にうち勝</strong></p>
        <p class="genndaibun">その相手、新当流有馬喜兵衛という兵法者に打勝ち</p>
        
        <p class="kobun block"><strong>十六歳にして、但馬國秋山と云強力の兵法者に打かち、</strong></p>
        <p class="genndaibun">十六歳にして但馬国の秋山という強力な兵法者に打勝った。</p>
        
        <p class="kobun block"><strong>二十一歳にして、都へのぼり、天下の兵法者に逢、数度の勝負をけつすと、いへども、勝利を得ざると云事なし。</strong></p>
        <p class="genndaibun">二十一歳にして都へ上り、天下（有数）の兵法者に出会い、何度も決闘勝負を行なったが、勝利を得ざるという事がなかった。</p>
        
        <p class="kobun block"><strong>其後、國々所々に至り、諸流の兵法者に行合、六十餘度迄勝負をすといへども、一度も其利をうしなはず。</strong></p>
        <p class="genndaibun">その後、諸国各地へ行って、さまざまな流派の兵法者と遭遇し、六十数回まで勝負を行なったけれども、一度もその勝利を失うことがなかった。</p>
    </div>
    
    <div class="page right">
        <div class="video-container" id="bilibili">
            <iframe src="//player.bilibili.com/player.html?bvid=BV1mccoeYErS&autoplay=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        
        <h2>五轮书序言</h2>
        <p class="kobun block"><strong>兵法之道，号曰二天一流</strong></p>
        <p class="genndaibun">我把自己的兵法称为二天一流</p>
        
        <p class="kobun block"><strong>数年锻炼之事，始欲以书著显之。</strong></p>
        <p class="genndaibun">经多年修行后，第一次决定将其记录成书</p>
        
        <p class="kobun block"><strong>时为宽永二十年十月上旬</strong></p>
        <p class="genndaibun">时间是宽永二十年（1643年）十月上旬</p>
        
        <p class="kobun block"><strong>上九州肥后之地岩户山，拜天，礼观音，向佛前。</strong></p>
        <p class="genndaibun">我登上九州肥后地区的岩户山，朝拜天地，向观音礼拜，在佛前祈愿。</p>
        
        <p class="kobun block"><strong>生国为播磨之武士，新免武藏守藤原玄信，年届六十。</strong></p>
        <p class="genndaibun">我，出身于播磨国的武士，新免武藏守藤原玄信，至今已年满六十</p>
        
        <p class="kobun block"><strong>吾自幼年之时，心系兵法之道，十三岁初试胜负。</strong></p>
        <p class="genndaibun">我自年少时便专注于兵法之道，十三岁时初次参与决斗。</p>
        
        <p class="kobun block"><strong>其对手乃新当流有马喜兵卫之兵法者，吾战而胜之</strong></p>
        <p class="genndaibun">击败了新当流的兵法家有马喜兵卫</p>
        
        <p class="kobun block"><strong>十六岁时，又胜但马国秋山之强力兵法者。</strong></p>
        <p class="genndaibun">十六岁时，又击败了但马国的强者秋山</p>
        
        <p class="kobun block"><strong>二十一岁时，上京于都，遇天下兵法者，数度胜负交锋，而无一败绩。</strong></p>
        <p class="genndaibun">二十一岁时，我前往京都，与天下有名的剑术家较量，多次决斗中，我从未尝败绩</p>
    </div>
</div>
</template>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>

